'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultValueFormatter(value) {
  if ((0, _lodash.isEmpty)(value)) {
    return '--';
  }
  return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: value } });
}

exports.default = {
  defaultValueFormatter: defaultValueFormatter
};
module.exports = exports['default'];